<img [class.ac-progress-center]="center" [src]="path">
